var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagePost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image-square-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M55.7353 59.0977L51.8778 55.0658C50.0165 53.1199 49.0857 52.1471 48.0178 51.7915C47.0784 51.4788 46.0688 51.4902 45.1361 51.8244C44.0756 52.2044 43.1651 53.1982 41.3441 55.1857L32.102 64.8077M55.7353 59.0977L56.5248 58.2726C58.3884 56.3245 59.3201 55.3505 60.3894 54.9949C61.3297 54.6821 62.34 54.6946 63.2733 55.03C64.3343 55.4112 65.2447 56.4076 67.0654 58.4003L69 60.4527M55.7353 59.0977L65.0109 68.894M32.102 64.8077C32.1737 65.422 32.2959 65.9075 32.5041 66.3383C32.9475 67.2555 33.655 68.0014 34.5253 68.4686C35.5146 69 36.8097 69 39.4 69H61.6C63.1131 69 64.1844 69 65.0109 68.894M32.102 64.8077C32 63.9351 32 62.8027 32 61.2V37.8C32 35.0698 32 33.7046 32.5041 32.6618C32.9475 31.7445 33.655 30.9987 34.5253 30.5314C35.5146 30 36.8097 30 39.4 30H61.6C64.1902 30 65.4855 30 66.4748 30.5314C67.3449 30.9987 68.0526 31.7445 68.4959 32.6618C69 33.7046 69 35.0698 69 37.8V60.4527M69 60.4527V61.2C69 63.9302 69 65.2955 68.4959 66.3383C68.0526 67.2555 67.3449 68.0014 66.4748 68.4686C66.0634 68.6897 65.599 68.8186 65.0109 68.894M62.0625 42.1872C62.0625 44.8797 59.9919 47.0623 57.4375 47.0623C54.8831 47.0623 52.8125 44.8797 52.8125 42.1872C52.8125 39.4948 54.8831 37.3122 57.4375 37.3122C59.9919 37.3122 62.0625 39.4948 62.0625 42.1872Z",
    stroke: "#00C853",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePost);
export default __webpack_public_path__ + "static/media/imagePost.5bd5a42c11334eac06dec78d7eae8094.svg";
export { ForwardRef as ReactComponent };